export default "__VITE_ASSET__2f3fdec1__"